module.exports = __webpack_public_path__ + "stylesheets/tabs_32e7a08c8e5a8da5185273ffab5307fb.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/tabs.less
// module id = 4eYb
// module chunks = 151